import * as Yup from 'yup'

const cashRegisterValidator = Yup.object ({
  openedAt: Yup
    .string ()
    .required ('Selecione a data e hora de abertura'),
})

export default cashRegisterValidator
